module.exports = __webpack_public_path__ + "static/media/logo-cropped.b9f54775.png";